<template>
  <div v-loading.fullscreen.lock="isLoading">
    <div style="margin-left: 7em; margin-right: 7em">
      <el-form ref="form" :model="addForm">
         <el-row>
            <el-form-item
              label="編號"
              required
              style="margin-bottom: -1em"
            ></el-form-item>
            <h4 v-if="this.id">{{this.id}}</h4>

            <el-input
              v-else
              style="margin-bottom: 1em"
              placeholder="請輸入書目編號"
              v-model="addForm.id"
            ></el-input>

            <el-form-item
              label="書目名稱"
              required
              style="margin-bottom: -1em"
            ></el-form-item>
            <el-input
              style="margin-bottom: 1em"
              placeholder="請輸入書目名稱"
              v-model="addForm.bookName"
            ></el-input>

            <el-form-item
              label="類別"
              required
              style="margin-bottom: -1em;"
            ></el-form-item>
            <el-input
              style="margin-bottom: 1em"
              placeholder="請輸入類別(A、Ｂ)"
              v-model="addForm.bookType"
            ></el-input>

            <el-form-item
              label="作者"
              required
              style="margin-bottom: -1em"
            ></el-form-item>
            <el-input
              style="margin-bottom: 1em"
              placeholder="請輸入作者"
              v-model="addForm.author"
            ></el-input>

            <el-form-item 
              label="版本" 
              style="margin-bottom: -1em;">
            </el-form-item>
             <el-input
              style="margin-bottom: 1em"
              placeholder="版本"
              v-model="addForm.version"
            ></el-input>

          </el-row>
        <el-row type="flex" justify="center">
          <el-button @click="closeDialog">取消</el-button>
          <el-button v-if="id==''" @click="check(false)" type="primary">新增</el-button>
          <el-button v-else id="test_lifeClass_btAddgo" @click="check(false)" type="primary">儲存</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import API from "@/api/";
import Utils from "@/utils";
import { InformType } from "@/utils/InformType";

export default {
  name: "bookAdd",
  props: {
    clickTime: Date,
    id: { String, default: "" },
  },
  watch: {
    clickTime: function () {
      console.log("clickTime watch");
      console.log("id", this.id);
      this.query();
    },
  },
  created: function () {
    this.query();
  },
  data() {
    return {
      isLoading: false,
      addForm: {
        id: "",
        bookName: "",
        bookType: "",
        author: "",
        version: "",
      },
    };
  },
  methods: {
    query() {
      if (this.id) {
        console.log("讀取");
        this.isLoading = true;
        API.book.show(this.id).then((res) => {
          this.addForm = res.data;
          this.isLoading = false;
        });
      }else {
        this.addForm= {
          id: "",
          bookName: "",
          bookType: "",
          author: "",
          version: "",
        };
      }
    },
    closeDialog() {
      this.$emit("close");
    },
    check() {
      if (Utils.Check.isNull(this.addForm.id)&&isNaN(this.id)) {
        Utils.Message.send("書籍編號不能為空!", InformType.ERROR);
        return;
      } 

      if (Utils.Check.isNull(this.addForm.bookName)) {
        Utils.Message.send("書籍名稱不能為空!", InformType.ERROR);
        return;
      } 
      if (Utils.Check.isNull(this.addForm.bookType)) {
        Utils.Message.send("類別不能為空!", InformType.ERROR);
        return;
      } 
      if (Utils.Check.isNull(this.addForm.author)) {
        Utils.Message.send("作者不能為空!", InformType.ERROR);
        return;
      } 
      console.log("檢查成功");
      //去空白
      this.addForm.id=this.addForm.id.replaceAll(/\s+/g, '');
      this.addForm.bookType=this.addForm.bookType.replaceAll(/\s+/g, '');
      this.update();
      
    },
    update() {
      if (this.id) {
        console.log("修改",this.id, this.addForm);
        this.isLoading = true;
        API.book.update(this.id, this.addForm).then(() => {
          Utils.Message.send("修改書籍成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.closeDialog();
        }).catch(() => {
          this.isLoading = false;
        });
      } else {
        console.log("新增");
        this.isLoading = true;
        API.book.add(this.addForm).then(() => {
          Utils.Message.send("新增書籍成功!", InformType.SUCCESS);
          this.isLoading = false;
          this.closeDialog();
        }).catch(() => {
          this.isLoading = false;
        });
      }
    },
  },
};
</script>

<style>
</style>